var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    alt: "Printer",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0469 5.5043V0.6875H3.95312V5.5043C3.07266 5.54942 2.24309 5.9307 1.63547 6.56949C1.02786 7.20828 0.688546 8.05588 0.6875 8.9375V17.1875H3.60938V15.8125H2.0625V8.9375C2.06311 8.39068 2.28061 7.86643 2.66727 7.47977C3.05393 7.09311 3.57818 6.87561 4.125 6.875H17.875C18.4218 6.87561 18.9461 7.09311 19.3327 7.47977C19.7194 7.86643 19.9369 8.39068 19.9375 8.9375V15.8125H18.0469V17.1875H21.3125V8.9375C21.3115 8.05588 20.9721 7.20828 20.3645 6.56949C19.7569 5.9307 18.9273 5.54942 18.0469 5.5043V5.5043ZM16.6719 5.5H5.32812V2.0625H16.6719V5.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0156 8.59375H18.3906V9.96875H17.0156V8.59375ZM4.98438 11.3438H3.26562V12.7188H4.98438V21.3125H16.6719V12.7188H18.3906V11.3438H4.98438ZM15.2969 19.9375H6.35938V12.7188H15.2969V19.9375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.4aa7331dc5f6e2842dc6f3a0063d85e9.svg";
export { ForwardRef as ReactComponent };